"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenChildren = void 0;
var react_1 = __importDefault(require("react"));
var flattenChildren = function (children) {
    var xs = react_1.default.Children.toArray(children).filter(react_1.default.isValidElement);
    return xs.reduce(function (acc, child) {
        if (child.type === react_1.default.Fragment) {
            return acc.concat((0, exports.flattenChildren)(child.props.children));
        }
        return __spreadArray(__spreadArray([], __read(acc), false), [child], false);
    }, []);
};
exports.flattenChildren = flattenChildren;
//# sourceMappingURL=flattenChildren.js.map